
import MenuAddNewItemDialog from "../../components/menu/menu-add-new-item-dialog.vue";

export default {
  components: {
    MenuAddNewItemDialog
  },
  data: () => {
    return {
      showAddNewDialog: false
    };
  },
  methods: {
    handleClick() {
      this.$vuetify.breakpoint.smAndDown
        ? (this.showAddNewDialog = true)
        : this.$router.push("/menu/new/item");
    }
  }
};
